// extracted by mini-css-extract-plugin
export default {"stringInput":"StringInput_stringInput__v6BWR"};